import { render, staticRenderFns } from "./waschepacket.vue?vue&type=template&id=a3064b24&"
import script from "./waschepacket.vue?vue&type=script&lang=js&"
export * from "./waschepacket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a3064b24')) {
      api.createRecord('a3064b24', component.options)
    } else {
      api.reload('a3064b24', component.options)
    }
    module.hot.accept("./waschepacket.vue?vue&type=template&id=a3064b24&", function () {
      api.rerender('a3064b24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2U8q6LTOagjIH/JS/comp/waschepacket.vue"
export default component.exports